import { Anchor, Box, Button, CheckBox, FileInput, FormField, Grid, ResponsiveContext, Select, Text, TextArea, TextInput } from "grommet";
import * as React from "react";
import AutoSizeTextArea from "../components/AutoSizeTextArea";
import Flag from "../components/Flag";
import { ImagePicker } from "../components/ImagePicker";
import ThemeBuilder from "../components/ThemeBuilder";
import MapLogoPicker from "./MapLogoPicker";
import MapSplashPicker from "./MapSplashPicker";

const MapDetails = ({ map, isBusy, onChange }) => {
    const [name, setName] = React.useState(map.name || "");
    const [logoUri, setLogoUri] = React.useState(map.logoUri || "");
    const [splashUri, setSplashUri] = React.useState(map.splashUri || "");
    const [contentUri, setContentUri] = React.useState(map.contentUri || "");
    const [description, setDescription] = React.useState(map.description || "");
    const [isPublic, setIsPublic] = React.useState(map.isPublic || false);

    const [logoContent, setLogoContent] = React.useState("");
    const [splashContent, setSplashContent] = React.useState("");
    const [content, setContent] = React.useState("");

    const [mapFileExt, setMapFileExt] = React.useState("");

    React.useEffect(() => {
        onChange({ description, name, logoUri, logoContent, splashUri, splashContent, content, isPublic, mapFileExt });
    }, [description, name, logoUri, logoContent, splashUri, splashContent, content, isPublic, mapFileExt]);

    const size = React.useContext(ResponsiveContext);

    React.useEffect(() => {
        if (map.logoUri && logoUri != map.logoUri) {
            setLogoUri(map.logoUri);
        }
        if (map.splashUri && splashUri != map.splashUri) {
            setSplashUri(map.splashUri);
        }
        if (map.contentUri && contentUri != map.contentUri) {
            setContentUri(map.contentUri);
        }
    }, [map.logoUri, map.splashUri, map.contentUri]);

    const handleLogoChange = ({ uri, content }) => {
        if (content) {
            setLogoContent(content);
            setLogoUri("");
        } else if (uri) {
            setLogoUri(uri);
            setLogoContent("");
        }
    };

    const handleSplashChange = ({ uri, content }) => {
        if (content) {
            setSplashContent(content);
            setSplashUri("");
        } else if (uri) {
            setSplashUri(uri);
            setSplashContent("");
        }
    };

    return (
        <div>
            <>
                <Grid columns={["auto"]} gap="small">
                    <CheckBox label="Public" checked={isPublic} onChange={(e) => setIsPublic(e.target.checked)} disabled={isBusy} />

                    <FormField label="Map Name">
                        <TextInput value={name} onChange={(e) => setName(e.target.value)} disabled={isBusy} />
                    </FormField>

                    <FormField label="Description">
                        <AutoSizeTextArea value={description} onChange={(e) => setDescription(e.target.value)} disabled={isBusy} />
                    </FormField>

                    <Box fill={true}>
                        <MapLogoPicker uri={logoUri} disabled={isBusy} onSelect={handleLogoChange}></MapLogoPicker>
                    </Box>
                    <Box fill={true}>
                        <MapSplashPicker uri={splashUri} disabled={isBusy} onSelect={handleSplashChange}></MapSplashPicker>
                    </Box>
                    <Box fill={true}>
                        <FileInput
                            name="file"
                            onChange={(event) => {
                                if (event) {
                                    setContent("");
                                    const fileList = event.target.files;
                                    if (fileList && fileList.length > 0) {
                                        const file = fileList[0];
                                        const reader = new FileReader();

                                        reader.addEventListener(
                                            "load",
                                            () => {
                                                setContent(reader.result as string);
                                                // @ts-ignore
                                                setMapFileExt(file.name.split(".").pop());
                                            },
                                            false
                                        );

                                        if (file) {
                                            reader.readAsDataURL(file);
                                        }
                                    }
                                }
                            }}
                        />
                        <Box direction="row" justify="end" margin={{ top: "small" }}>
                            {contentUri && <Button href={contentUri} download label="Download Map"></Button>}
                        </Box>
                    </Box>
                </Grid>
            </>
        </div>
    );
};

export default MapDetails;
